import img0 from "../../../assets/img/partners/0.png";
import img1 from "../../../assets/img/partners/1.png";
import img2 from "../../../assets/img/partners/2.png";
import img3 from "../../../assets/img/partners/3.png";
import img4 from "../../../assets/img/partners/4.png";
import img5 from "../../../assets/img/partners/5.png";
import img6 from "../../../assets/img/partners/6.png";
import img7 from "../../../assets/img/partners/7.png";
import img8 from "../../../assets/img/partners/8.png";
import img9 from "../../../assets/img/partners/9.png";
import img10 from "../../../assets/img/partners/10.png";
import img11 from "../../../assets/img/partners/11.png";
import img12 from "../../../assets/img/partners/12.jpg";
import img13 from "../../../assets/img/partners/13.png";
import img14 from "../../../assets/img/partners/14.png";
import img15 from "../../../assets/img/partners/15.png";
import img16 from "../../../assets/img/partners/16.png";
import img17 from "../../../assets/img/partners/17.png";
import img18 from "../../../assets/img/partners/18.png";
import img19 from "../../../assets/img/partners/19.png";
import img20 from "../../../assets/img/partners/20.png";
import img21 from "../../../assets/img/partners/21.png";
import img22 from "../../../assets/img/partners/22.png";
import img23 from "../../../assets/img/partners/23.png";
import img24 from "../../../assets/img/partners/24.png";
import img25 from "../../../assets/img/partners/25.png";
import img26 from "../../../assets/img/partners/26.png";
import img27 from "../../../assets/img/partners/27.png";
import img28 from "../../../assets/img/partners/28.png";
import img29 from "../../../assets/img/partners/29.png";
import { useTranslation } from "react-i18next";


import SectionHeading from "../../../components/SectionHeading";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const SecTrust = ({ data }) => {
  const { t } = useTranslation();

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 6,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };
  return (
    <div className="trust-section section-padding-0-70">
      <SectionHeading title={t('ourFriends')} text={t('partners')} />
      <div className="container">
        <div
          style={{
            padding: 15,
            backgroundColor: "rgba(255, 255, 255, 0.3)",
          }}
        >
          <Carousel responsive={responsive}>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 120 }} draggable="false" src={img0} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 80 }} draggable="false" src={img1} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 140 }} draggable="false" src={img2} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 100 }} draggable="false" src={img3} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 140 }} draggable="false" src={img4} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 160 }} draggable="false" src={img5} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 160 }} draggable="false" src={img6} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 160 }} draggable="false" src={img7} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 140 }} draggable="false" src={img8} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img style={{ width: 120 }} draggable="false" src={img9} alt="" />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 100 }}
                draggable="false"
                src={img10}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 100 }}
                draggable="false"
                src={img11}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 120 }}
                draggable="false"
                src={img12}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 160 }}
                draggable="false"
                src={img13}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 100 }}
                draggable="false"
                src={img14}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 130 }}
                draggable="false"
                src={img15}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 130 }}
                draggable="false"
                src={img16}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 130 }}
                draggable="false"
                src={img17}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 150 }}
                draggable="false"
                src={img18}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 160 }}
                draggable="false"
                src={img19}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 150 }}
                draggable="false"
                src={img20}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 160 }}
                draggable="false"
                src={img21}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 130 }}
                draggable="false"
                src={img22}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 130 }}
                draggable="false"
                src={img23}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 150 }}
                draggable="false"
                src={img24}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 130 }}
                draggable="false"
                src={img25}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 140 }}
                draggable="false"
                src={img26}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 140 }}
                draggable="false"
                src={img27}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ width: 180 }}
                draggable="false"
                src={img28}
                alt=""
              />
            </div>
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                style={{ height: 100 }}
                draggable="false"
                src={img29}
                alt=""
              />
            </div>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default SecTrust;
